<template>
  <div>
    <label class="checkbox" v-for="campus of campuses" :key="campus.code">
      <input type="checkbox" v-model="selected" :value="campus" />
      {{ campus.abbreviation }}
    </label>
  </div>
</template>

<script lang="ts">
import { Campus, University } from '@/store/master/types'
import { RootState } from '@/store/types'
import _ from 'lodash'
import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator'

@Component
export default class CampusesInput extends Vue {
  @Prop({ required: true }) value!: Campus[]

  @Prop() belongsToUniversity?: University

  private created() {
    this.$store.dispatch('fetchMasterCampuses')
  }

  private get campuses(): Campus[] {
    const { campuses } = (this.$store.state as RootState).master
    if (this.belongsToUniversity) {
      return _.filter(campuses, { universityCode: this.belongsToUniversity.code })
    }
    return campuses
  }

  private get selected(): Campus[] {
    return this.value
  }

  private set selected(campuses: Campus[]) {
    this.$emit('input', campuses)
  }

  @Watch('belongsToUniversity')
  private changedUniversity() {
    this.selected = []
  }
}
</script>

<style scoped>
input[type="checkbox"] {
  margin-right:8px;
}
.checkbox {
  margin-right:20px;
}
</style>
